<template>
<div id="water-mark-show-history">
    <div class="edit_history" id="edit_history"></div>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import cookies from "js-cookie";
import { TocaHistoryEditor } from "@toca/toca-edit";
import "@toca/toca-edit/dist/style.css";
import { mapState } from "vuex";
import { EDITOR_ENV_MAP } from "@/constants/file";
import { watermark } from "toca-watermark";

export default {
  props: {
    // rootId: {
    //     type: String,
    // },
    fileId: {
      type: String
    }
    // metadata: {
    //     type: Object,
    // },
    // isPublic: {
    //     type: Boolean,
    // },
    // editorMode: {
    //     type: String,
    //     default: "PREVIEW"
    // }
  },
  name: "edit_history",
  components: {},
  data() {
    return {
      history: null
    };
  },
  methods: {
    initHistory() {
      const userId = cookies.get("userId") || "";
      const token = cookies.get("token") || "";
      const deviceId = cookies.get("deviceId") || "";
      const spaceId = cookies.get("spaceId") || "";

      const userInfo = {
        userId,
        token,
        deviceId,
        spaceId,
        userDetail: this.currentUser,
        ...this.currentUser
      };

      let env = EDITOR_ENV_MAP[process.env.VUE_APP_STATIC_NODE_ENV];
      this.history = new TocaHistoryEditor("#edit_history", {
        fileId: this.fileId,
        env,
        onBackFunc: (html) => {
          this.$emit("handleShowHistory", false);
          if (html) {
            window["editor"]?.commands?.clearContent();
            window["editor"]?.commands?.setContent(html, true);
          }
        },
        userInfo: userInfo,
        docInfo: this.docInfo,
        locale:
        this.cloudI18n ||
        localStorage.getItem("tci18nLocale") ||
        navigatorLang[navigator.language] ||
        "zh-cn"
      });
    }
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
      currentUser: (state) => state.currentUserInfo,
      docInfo: (state) => state.docInfo,
      cloudI18n: (state) => state.cloudI18n
    })
  },
  watch: {
















    // currentUser: {
    //     handler(value) {
    //         console.log('currentUser', value)
    //         // 渲染水印
    //         if (value?.employeeNo && value?.memberName) {
    //             console.log('渲染水印', value)
    //             // setTimeout(() => {
    //             waterMark.set(value?.memberName + ' ' + value?.employeeNo, 'water-mark-show-history')
    //             // }, 500)
    //         } else {
    //             waterMark.set('管家云文档')
    //         }
    //     },
    //     immediate: true,
    //     deep: true
    // },
  }, mounted() {this.initHistory();setTimeout(() => {if (!!this.currentUser?.employeeNo && !!this.currentUser?.memberName) {// setTimeout(() => {
          watermark.set(this.currentUser?.memberName + " " + this.currentUser?.employeeNo, "water-mark-show-history", "water-mark-history", "calc(100vh - 54px)"); // }, 500)
        } else {watermark.set(intl.$t("同程管家#!!!#src/pages/H5/Cloud/views/EditHistory.vue_1"), "water-mark-show-history", "water-mark-history", "calc(100vh - 54px)"
          );
        }
      });
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
#water-mark-show-history {
  width: 100%;
  height: 100%;
}
.edit_history {
  max-width: 100%;
  max-height: 100%;
  width: 100% !important;
  height: 100% !important;
  background-color: #ffffff;
}

#water-mark-show {
  position: relative;
  z-index: 99;
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
